import service from "../service.js";
// import qs from 'qs'

// 登录
export function reqAuthLogin(data) {
  return service({
    method: "post",
    url: "/auth/login",
    data,
  });
}
export function reqUserTokenAccessEnabled() {
  return service({
    method: "get",
    url: "/user/tokenAccessEnabled",
  });
}
export function reqGetCurrentUserInfo() {
  return service({
    method: "get",
    url: "/auth/user",
  });
}
export function reqLogout() {
  return service({
    method: "post",
    url: "/auth/logout",
  });
}

// 客户列表
export function reqGetCustomers(data) {
  return service({
    method: "get",
    url: "customers",
    params: data,
  });
}

// 删除客户
export function reqDeleteCustomer(id) {
  return service({
    method: "delete",
    url: `customer/${id}`,
  });
}

// 查询客户
export function reqGetCustomer(customerTitle) {
  return service({
    method: "get",
    url: `tenant/customers?customerTitle=${customerTitle}`,
  });
}

// 根据customerTitle获取customerId
export function reqGetCustomerId(customerTitle) {
  return service({
    method: "get",
    url: `tenant/customers?customerTitle=${customerTitle}`,
  });
}

// 新增客户
export function reqSaveCustomer(data) {
  return service({
    method: "post",
    url: "customer",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 设备列表
export function reqGetDevices(data) {
  return service({
    method: "get",
    url: "tenant/deviceInfos",
    params: data,
  });
}

// 删除设备
export function reqDeleteDevice(deviceId) {
  return service({
    method: "delete",
    url: `device/${deviceId}`,
  });
}

// 查询设备
export function reqGetDevice(deviceName) {
  return service({
    method: "get",
    url: `tenant/devices?deviceName=${deviceName}`,
  });
}

export function reqGetDeviceInfo(deviceId) {
  return service({
    method: "get",
    url: `device/info/${deviceId}`,
  });
}

// 新增设备
export function reqSaveDevice(data) {
  return service({
    method: "post",
    url: "device",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 查询设备项目在线率
export function reqOnlineDevice(customerTitle) {
  const currentHost = window.location.hostname;
  var baseURL = "";
  if (currentHost === "47.92.100.44") {
    baseURL = `http://${currentHost}:8089/openapi`;
  } else {
    baseURL = `http://47.92.164.101:8089/openapi`;
  }
  return service({
    method: "get",
    url: `v1.0/customerDevice/onlineDevice?customerTitle=${customerTitle}`,
    baseURL: baseURL,
  });
}

// 获取设备历史数据
export function reqGetTimeseries(data) {
  const currentHost = window.location.hostname;
  var baseURL = `http://${currentHost}:28080/api`;
  if (currentHost === "localhost") {
    baseURL = `http://${currentHost}:8080/api`;
  } else {
    baseURL = `http://${currentHost}:28080/api`;
  }
  return service({
    method: "get",
    url: `plugins/telemetry/${data.entityType}/${data.entityId}/values/timeseries?keys=${data.keys}&startTs=${data.startTs}&endTs=${data.endTs}&limit=${data.limit}`,
    data,
    baseURL: baseURL,
  });
}

// 获取设备最新数据
export function reqGetLatestTimeseries(data) {
  return service({
    method: "get",
    url: `plugins/telemetry/${data.entityType}/${data.entityId}/values/timeseries?keys=${data.keys}`,
    data,
  });
}

// 获取首页设备列表
export function reqGetHomeDevicesTs(data) {
  return service({
    method: "get",
    url: `plugins/telemetry/${data.entityType}/${data.entityId}/values/timeseries`,
    // url:`plugins/telemetry/${data.entityType}/${data.entityId}/values/timeseries?keys=${data.keys}`,
    data,
  });
}

export function reqGetHomeDevicesTs1(data) {
  return service({
    method: "get",
    url: `plugins/telemetry/${data.entityType}/${data.entityId}/values/timeseries?keys=PACK_SN`,
    data,
  });
}

// 根据客户获取设备列表
export function reqGetCustomerDevices(data) {
  return service({
    method: "get",
    url: `customer/${data.customerId}/devices`,
    params: data,
  });
}

// -------------------------------Customer--------------------------------

// 客户Id
export function reqGetUser(data) {
  return service({
    method: "get",
    url: `users?pageSize=1&page=0`,
    params: data,
  });
}

// -------------------------------Admin--------------------------------
export function reqGetTenants(data) {
  return service({
    method: "get",
    url: "tenantInfos",
    params: data,
  });
}

export function reqGetTenantProfiles(data) {
  return service({
    method: "get",
    url: "tenantProfiles",
    params: data,
  });
}

export function reqGetGeneralSetting(data) {
  return service({
    method: "get",
    url: `admin/settings/${data.baseUrl}`,
    data,
  });
}

export function reqGetQueues(data) {
  return service({
    method: "get",
    url: "queues?pageSize=10&page=0&sortProperty=createdTime&sortOrder=DESC&serviceType=TB_RULE_ENGINE",
    data,
  });
}

export function reqGetDevicesCount(data) {
  return service({
    method: "post",
    url: "entitiesQuery/count",
    data,
  });
}
export function reqGetDevicesFindLocal(data) {
  return service({
    method: "post",
    url: "entitiesQuery/find",
    data,
  });
}

// 用户列表
export function reqGetCustomerUsers(data) {
  return service({
    method: "get",
    url: `customer/${data.customerId}/users`,
    params: {
      page: data.page,
      pageSize: data.pageSize,
      sortPropert: data.sortProperty,
      sortOrder: data.sortOrder,
    },
  });
}

// 新增用户
export function reqSaveUser(data) {
  return service({
    method: "post",
    url: "user?sendActivationMail=false",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 获取用户激活链接
export function reqGetActivationLink(userId) {
  return service({
    method: "get",
    url: `user/${userId}/activationLink`,
  });
}

// 激活用户
export function reqActivateUser(data) {
  return service({
    method: "post",
    url: "noauth/activate?sendActivationMail=true",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 删除用户
export function reqDeleteUser(userId) {
  return service({
    method: "delete",
    url: `user/${userId}`,
  });
}

// 查询用户设备
export function reqFindCustomerDevice(data) {
  return service({
    method: "get",
    url: `customer/${data.customerId}/deviceInfos?pageSize=1&page=0&textSearch=${data.deviceName}&sortProperty=createdTime&sortOrder=DESC&deviceProfileId=`,
  });
}

// 分配设备
export function reqAssignDeviceToCustomer(data) {
  return service({
    method: "post",
    url: `customer/${data.customerId}/device/${data.deviceId}`,
    data,
  });
}

// 取消分配设备
export function reqUnassignDeviceFromCustomer(deviceId) {
  return service({
    method: "delete",
    url: `customer/device/${deviceId}`,
  });
}

// 电子围栏
// 47.92.164.101:28088/electricFence/create
export function reqCreateElectricFence(data) {
  return service({
    method: "post",
    url: "electricFence/create",
    baseURL: "http://47.92.164.101:28089",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

export function reqDeleteElectricFence(data) {
  return service({
    method: "post",
    url: "alarm/deleteAlarmMode",
    baseURL: "http://47.92.164.101:28089",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

export function reqCreateAlarmMode(data) {
  return service({
    method: "post",
    url: "alarm/createAlarmMode",
    baseURL: "http://47.92.164.101:28089",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

// 查询设备B1数据
export function reqGetAllDevices(data) {
  return service({
    method: "get",
    // url: `frame/timeseries/batch?pageSize=${data.pageSize}&page=${data.page}&customerTitle=${data.customerTitle}`,
    url: `frame/timeseries/batch?pageSize=${data.pageSize}&page=${data.page}`,
    baseURL: "http://47.92.164.101:8089",
    data,
  });
}
export function reqGetAllDevices1(data) {
  return service({
    method: "get",
    url: `frame/timeseries/batch?pageSize=${data.pageSize}&page=${data.page}&customerTitle=${data.customerTitle}`,
    // url: `frame/timeseries/batch?pageSize=${data.pageSize}&page=${data.page}`,
    baseURL: "http://47.92.164.101:8089",
    data,
  });
}
// 按 imei号查询设备数据
export function reqFindDeviceB1ByImei(data) {
  return service({
    method: "get",
    url: `frame/timeseries?imei=${data.name}`,
    baseURL: "http://47.92.164.101:8089",
    data,
  });
}
// 批量按页查询设备数据
export function reqFindDevicesB1(data) {
  return service({
    method: "get",
    // url: `frame/timeseries/timeseries/batch?pageSize=${data.pageSize}&page=${data.page}&customerTitle=${data.customerTitle}`,
    url: `frame/timeseriesHis/batch?pageSize=${data.pageSize}&page=${data.page}&customerTitle=${data.customerTitle}`,
    baseURL: "http://47.92.164.101:8089",
    data,
  });
}

// 按 error 类型查询设备
export function reqFindDevicesByError(data) {
  return service({
    method: "get",
    url: `frame/timeseries/alarm?error=${data.errorType}&page=${data.page}&pageSize=${data.pageSize}`,
    baseURL: "http://47.92.164.101:8089",
    data,
  });
}
